const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/userdevice/index', params)
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/userdevice/update', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
